import { ApplePay } from './apple-pay';
import { GooglePay } from './google-pay';
import { WalletPaymentMethodInfo } from './wallet-payment-method-info';

export type WalletPaymentMethod = ApplePay | GooglePay;

export const isWalletPaymentMethod = (walletPaymentMethod: WalletPaymentMethod | WalletPaymentMethodInfo): walletPaymentMethod is WalletPaymentMethod =>
  'description' in walletPaymentMethod && 'refusedPayment' in walletPaymentMethod;
